<template>
  <user-survey-form
    :busy="busy"
    :surveys="surveys"
    :userSurveys="userSurveys"
    class="mb-4"
    @surveyUpdated="onSurveyUpdated"
  />
</template>

<script>
  import { mapState } from 'vuex';
  import UserSurveyForm from './UserSurveyForm';

  export default {
    name: 'UserSurveys',
    components: { UserSurveyForm },
    props: {
      surveys: Array,
    },
    data() {
      return {
        busy: false,
        userSurveys: [],
      };
    },
    created() {
      this.getUserSurveys();
    },
    computed: {
      ...mapState({
        userForm: state => state.salesforceUserForm.userForm,
      }),
    },
    methods: {
      async onSurveyUpdated(event) {
        this.busy = true;
        if (event.status) {
          await this.assignSurvey(event.id);
        } else {
          await this.deleteSurvey(event.id);
        }
        this.busy = false;
      },
      getUserSurveys() {
        this.busy = true;
        axios
          .get(`/api/salesforce/surveys/${this.userForm.ID}`)
          .then(results => {
            this.userSurveys = results.data.items;
            if (this.userSurveys.length > 0) {
              this.surveys.forEach(survey => {
                this.userSurveys.forEach(userSurvey => {
                  if (survey.name === userSurvey['event_name']) {
                    survey['status'] = true;
                  }
                });
              });
            }
            this.busy = false;
          })
          .catch(error => {
            console.error(error);
            this.handleError(`Error getting users data`);
            this.busy = false;
          });
      },
      async assignSurvey(eventId) {
        let payload = {
          user_id: this.userForm.ID,
          event_id: eventId,
        };
        await axios
          .post(`/api/salesforce/surveys`, payload)
          .then(results => {
            this.$bvToast.toast(`Survey attached to ${this.userForm.name}`, {
              title: 'Success',
              autoHideDelay: 5000,
              appendToast: true,
              variant: 'success',
            });
            this.getUserSurveys();
          })
          .catch(err => {
            console.log(err);
            this.handleError(`Could Not Add Survey - ${err.response.data.errorMessage}`);
          });
        this.busy = false;
      },
      async deleteSurvey(eventId) {
        let relationship = this.userSurveys.find(survey => survey.event_id === eventId);
        await axios
          .delete(`/api/salesforce/surveys/${relationship.id}`)
          .then(results => {
            this.$bvToast.toast(`Survey detached from ${this.userForm.name}`, {
              title: 'Success',
              autoHideDelay: 5000,
              appendToast: true,
              variant: 'success',
            });
            this.getUserSurveys();
          })
          .catch(err => {
            console.log(err);
            this.handleError(`Could Not Delete Survey - ${err.response.data.errorMessage}`);
          });
        this.busy = false;
      },
      handleError(message) {
        this.$bvToast.toast(message, {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'danger',
        });
      },
    },
  };
</script>
